var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 0C1.22874 0 0.333313 0.895431 0.333313 2V3.16147L8.77429 7.38197C9.1262 7.55792 9.54042 7.55792 9.89233 7.38197L18.3333 3.16147V2C18.3333 0.895431 17.4379 0 16.3333 0H2.33331Z",
    fill: "#062A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.83853L10.5632 8.72361C9.78895 9.11071 8.87768 9.11071 8.10347 8.72361L0.333313 4.83853V10C0.333313 11.1046 1.22874 12 2.33331 12H16.3333C17.4379 12 18.3333 11.1046 18.3333 10V4.83853Z",
    fill: "#062A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingEmail);
export default __webpack_public_path__ + "static/media/landing-email.fa68c418dd13825e051f6f8a9ceca4e2.svg";
export { ForwardRef as ReactComponent };